import { render, staticRenderFns } from "./Automezzi.vue?vue&type=template&id=0ad7aa64&"
import script from "./Automezzi.vue?vue&type=script&lang=js&"
export * from "./Automezzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports